import ui from './instantHoraryUi.json';
import data from './instantHoraryTranslations.json';
import { normalizeLanguage } from './languages';
type Catalog = { questions: Record<string, string>; categories: Record<string, string> };
const translations: Record<string, Catalog> = data;
export function horaryQuestionText(question: { id: string; text: string }, language?: string) {
  return translations[normalizeLanguage(language)].questions[question.id] || question.text;
}
export function horaryCategoryLabel(category: { id: string; label: string }, language?: string) {
  return translations[normalizeLanguage(language)].categories[category.id] || category.label;
}

// UI and API enum labels share the selected app language; calculation keys stay canonical.
export function horaryUi(language: string | undefined, key: string): string {
  const copy: Record<string, Record<string, string>> = ui;
  return copy[normalizeLanguage(language)][key] || copy.en[key] || key;
}
